import { render, staticRenderFns } from "./TipoOrcamentoTabela.vue?vue&type=template&id=20755927&lang=html&"
import script from "./TipoOrcamentoTabela.vue?vue&type=script&lang=js&"
export * from "./TipoOrcamentoTabela.vue?vue&type=script&lang=js&"
import style0 from "./TipoOrcamentoTabela.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/custom/abbrasil/spa/tipo-orcamento/TipoOrcamentoTabela.vue
// module id = 1545
// module chunks = 28